// extracted by mini-css-extract-plugin
module.exports = {"image":"global-module--image--26Fbl","imageRow":"global-module--imageRow--I37MR"};